import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks,  MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { Button } = wp.components;
const { useState } = wp.element;

export default ({ attributes, setAttributes, className }) => {
    const [localMedia, setLocalMedia] = useState(attributes.url);

    const handleOnSelectImage = ( media ) => {
        setAttributes({ url: media.url });
        setLocalMedia(media.url);
    };

    const handleOnChangeSubTitle = ( subtitle ) => {
        setAttributes({ subtitle });
    };

    return(
        <div className={ className }>
            <div className="wrapper">
                <div className="wp-block-image-text-horizontal-block__text">
                    <InnerBlocks
                    template={[ ['core/heading'], ['core/paragraph'], ['core/button'] ]}
                    allowedBlocks={['email-form/block']}
                    />

                    <RichText
                    tagName="p"
                    className="Subtitle"
                    placeholder={__("Subtítulo da seção")}
                    value={attributes.subtitle}
                    onChange={handleOnChangeSubTitle}
                    />
                </div>

                <div className="wp-block-image-text-horizontal-block__image">
                    <div>
                    <MediaUploadCheck>
                        <MediaUpload
                        onSelect={handleOnSelectImage}
                        allowedTypes={["image"]}
                        render={({ open }) => (
                            <>
                            <Button
                                className="SelectImage"
                                onClick={open}
                            >
                            {__("Selecionar Imagem", "block")}
                            </Button>
                            </>
                        )}
                        />
                    </MediaUploadCheck>
                    </div>

                    <img src={localMedia} />
                </div>
            </div>
        </div>
    );
}